module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "com-model"
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/company'
      }
    }
  }, [_vm._v("企业设置")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("企业认证")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("提交次数限制：一天一次")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.companyInfo,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "管理者姓名",
      "prop": "legalName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.companyInfo.legalName),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "legalName", $$v)
      },
      expression: "companyInfo.legalName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "管理者联系电话",
      "prop": "legalPhone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.companyInfo.legalPhone),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "legalPhone", $$v)
      },
      expression: "companyInfo.legalPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "执照号码",
      "prop": "license"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.companyInfo.license),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "license", $$v)
      },
      expression: "companyInfo.license"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("输入营业执照号码或统一社会信用代码")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照",
      "prop": "licenseImg"
    }
  }, [_c('el-upload', {
    staticClass: "uploader-license",
    attrs: {
      "action": "/wapi/base/upload",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.companyInfo.licenseImg) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.companyInfo.licenseImg
    }
  }) : _c('div', [_c('i', {
    staticClass: "el-icon-plus uploader-icon"
  }), _vm._v(" "), _c('p', [_vm._v("点击上传")]), _vm._v(" "), _c('p', [_vm._v("营业执照")])])]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("格式要求：营业执照为图片，大小不超过1M")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "60px",
      "margin-bottom": "0",
      "padding-bottom": "60px"
    }
  }, [_c('div', {
    staticClass: "primary-btn button",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交审核")])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eecfa176","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/finance/companyAuth.vue
// module id = 923
// module chunks = 1